// Auth interface. Demo mode: a stub session for "Demo User" is always
// active so the app can be navigated without a real backend. When
// Supabase is configured this swaps to the real client and the demo
// session is replaced with whatever the user actually signs into.
//
// Public surface:
//   getSession()  → { user } | null
//   signIn(email, password)  → Promise<{ user } | { error }>
//   signOut()     → Promise<void>
//   onChange(fn)  → unsubscribe

import { isConfigured } from './config.js';

const DEMO_SESSION = {
  user: { email: 'demo@raceengineer', name: 'Demo User' },
  demo: true,
};

const listeners = new Set();
let session = isConfigured() ? null : DEMO_SESSION;

export function getSession() {
  return session;
}

export function onChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export async function signIn(email, password) {
  if (!isConfigured()) {
    // In demo mode you're already "signed in"; the form doesn't do
    // anything but doesn't need to error either.
    return { user: DEMO_SESSION.user };
  }
  // TODO: real Supabase sign-in goes here once config lands.
  return { error: 'Supabase client not implemented yet.' };
}

export async function signOut() {
  if (!isConfigured()) {
    // Demo mode: no-op. Pretending user is authenticated.
    return;
  }
  session = null;
  emit();
}

function emit() {
  for (const fn of listeners) fn(session);
}
